import {
  IndividualRegistration,
  IndividualRegistrationEmailConfirmationMethod,
  ErrorResultModel,
} from 'Core/Api/UserManagement/Api';
import { SecuredUserManagementClient } from 'Core/Api/UserManagement/SecuredUserManagementClient';
import { SwaggerException } from 'Core/Api/Kopp/Api';
import Utility from 'Core/Utility';
export class RegistrationWizardHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  RegisterIndividualUser(obj: IndividualRegistration) {
    let client = new SecuredUserManagementClient();
    client.showLoading = true;
    obj.emailConfirmationMethod = IndividualRegistrationEmailConfirmationMethod.Token;

    return client.registration_IndividualSignUp(obj).catch(Utility.formatError);
  }
}
